export default "__VITE_ASSET__Dp0tD4VZ__"